import React, { useEffect, useState } from 'react';
import { Breadcrumb, Col, Empty, Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import { RBHAlert, RBHBox, RBHButton, RBHError, RBHTable, RBHText, RBHTextInput } from '../../../shared/components';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { httpCreators, useLoadingSelector } from 'rbh-merchant-core';
import { MartCategoryService } from './redux/martCategory-service';
import styleText from '../../../shared/components/rbh-text/styles';
import { mainCreators } from '../../main-action';
import { MAIN_STATE_KEY } from '../../main-reducer';
import styles from './styles';
import styleButton from '../../../shared/components/rbh-button/styles';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { generalCreators } from '../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../redux/general/general-reducer';
import { DEFAULT_PAGE_SIZE, MODAL_TYPE } from '../../../redux/general/general-constant';
import styleImage from '../../../shared/components/rbh-image/styles';
import { ProfileOutlined, SearchOutlined } from '@ant-design/icons/lib';
import { martCategoryCreators } from './redux/martCategory-action';
import metrics from '../../../shared/theme/metrics';
import styleInput from '../../../shared/components/rbh-textinput/styles';
import './stylescss.css';
import { Colors, Images } from '../../../shared/theme';
import { MART_CATEGORY_STATE_KEY, martCategoryStateSelector } from './redux/martCategory-reducer';
import { MART_CATEGORY_REQUEST_ID_LIST } from './redux/martCategory-constant';
import { martCategorySagas } from './redux/martCategory-saga';
import { FormTransfer } from './components/FormTransfer';
export const MartCategoryScreen: React.FC<Props> = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(martCategoryStateSelector(MART_CATEGORY_STATE_KEY.CATEGORY_LIST)) as [];
  const isAlertSuccess = useSelector(martCategoryStateSelector(MART_CATEGORY_STATE_KEY.IS_ALERT_SUCCESS));
  const isAlertFailure = useSelector(martCategoryStateSelector(MART_CATEGORY_STATE_KEY.IS_ALERT_FAILURE));
  const loading = useLoadingSelector(MART_CATEGORY_REQUEST_ID_LIST.GET_MART_CATEGORY);
  const [transfer, setTransfer] = useState(null);

  const resetReload = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTransfer(null);
    dispatch(martCategoryCreators.callMartCategoryTnc());
  };
  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 4));
    resetReload();
  }, []);

  const toAddMartCategory = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(httpCreators.request({
      id: MART_CATEGORY_REQUEST_ID_LIST.GET_MASTER_MART_CATEGORY,
      sagaHandler: martCategorySagas.getMasterMartCategoryHandler as any,
      callbackParams: {
        onSuccessCallback: () => history.push('/main/addmartcategory'),
        onDismissCallback: () => {
          history.push('/main/martcategory');
          resetReload();
        }
      },
      service: MartCategoryService.getMasterMartCategory,
      serviceParams: false
    }));
  };

  const pushToMain = () => {
    history.push('/main');
  };

  const onDelete = (productCategoryMerchantId: number) => {
    dispatch(httpCreators.request({
      id: MART_CATEGORY_REQUEST_ID_LIST.DELETE_MART_CATEGORY,
      sagaHandler: martCategorySagas.deleteMartCategoryHandler as any,
      callbackParams: resetReload,
      service: MartCategoryService.deleteMartCategory,
      serviceParams: productCategoryMerchantId
    }));
  };

  const handleTransferProduct = (productCategoryDetail: any) => {
    dispatch(httpCreators.request({
      id: MART_CATEGORY_REQUEST_ID_LIST.GET_MASTER_MART_CATEGORY,
      sagaHandler: martCategorySagas.getMasterTransferMartCategoryHandler as any,
      callbackParams: {
        currentProductCategoryId: productCategoryDetail?.productCategoryId,
        onSuccessCallback: () => setTransfer(productCategoryDetail),
      },
      service: MartCategoryService.getMasterMartCategory,
      serviceParams: true
    }));
  };

  const columns = [
    {
      width: metrics.tableHeader.width725,
      className: 'mart-category-search-table',
      title: <FormattedMessage id={'main.mart.category.landing.table.column1'} />,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => {
        return (
          <RBHBox style={styles.searchBox}>
            <RBHTextInput
              placeholder={'main.mart.category.landing.table.column1.search'}
              data-testid={'search-mart-category-input'}
              id={'search-mart-category-input'}
              style={styleInput.inputTableSearch}
              value={selectedKeys[0]}
              onChange={(e: any) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={confirm}
              onBlur={confirm}
            />
          </RBHBox>
        );
      },
      filterIcon: (filtered: any) => (
        <SearchOutlined data-testid={'search-mart-category-icon'} id={'search-mart-category-icon'} translate={null}
          style={{ color: filtered ? Colors.lightPurple : undefined }} />
      ),
      onFilter: (value: any, all: any) => {
        return all.productCategoryNameTH.toString().toLowerCase().includes(value.toLowerCase()) ||
          all.productCategoryNameEN?.toString().toLowerCase().includes(value.toLowerCase());
      },
      onFilterDropdownVisibleChange: (visible: boolean) => {
        if (visible) {
          setTimeout(() => {
            const inputEl = document.getElementById('search-input');
            if (inputEl) {
              (inputEl as HTMLInputElement).select();
            }
          });
        }
      },
      render: (value: any, all: any, index: number) => {
        return (
          <RBHBox id={`martCategory-${index}`} style={{ width: metrics.tableHeader.width725 }}>
            <Row>
              {all.productCategoryGroupingId === 1 &&
                <Col>
                  <img src={Images.promotion} style={styles.iconPromotion}
                    id={`martCategory-icon-${index}`} data-testid={`martCategory-icon-${index}`} />
                </Col>
              }
              <Col>
                <RBHText style={all.productCategoryGroupingId === 1 ? styles.promotionText : styleText.textTableContentFakeBlack}
                  id={`productCategoryNameTH-${index}`} data-testid={`productCategoryNameTH-${index}`}>
                  {all.productCategoryNameTH}
                </RBHText>
                <RBHText style={all.productCategoryGroupingId === 1 ? styles.promotionText : styleText.textRegularGray}
                  id={`productCategoryNameEN-${index}`} data-testid={`productCategoryNameEN-${index}`}>
                  {all.productCategoryNameEN}
                </RBHText>
              </Col>
            </Row>
          </RBHBox>
        );
      }
    },
    {
      title: <FormattedMessage id={'main.mart.category.landing.table.column2'} />,
      align: 'center',
      render: (value: any, all: any, index: any) => {
        const transferProductCategory = `transferProductCategory-${index}`;
        return (
          <RBHBox onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            handleTransferProduct(all);
          }}>
            <EditOutlined data-testid={transferProductCategory} id={transferProductCategory}
              translate={null} style={styleImage.iconTable} />
          </RBHBox>
        );
      },
    },
    {
      title: <FormattedMessage id={'main.mart.category.landing.table.column3'} />,
      align: 'center',
      dataIndex: 'productCategoryMerchantId',
      render: (productCategoryMerchantId: any, all: any, index: number) => {
        const deleteMartCategory = `deleteMartCategory-${index}`;
        return (all.productCategoryGroupingId === 1 ? null :
          <RBHBox onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
            visible: true,
            onOk: () => onDelete(productCategoryMerchantId),
            modalTitle: 'main.cat_category_delete_header',
            modalContent: 'main.cat_category_delete_content',
            type: MODAL_TYPE.DELETE
          }))}>
            <DeleteOutlined data-testid={deleteMartCategory} id={deleteMartCategory}
              translate={null} style={styleImage.iconTable} />
          </RBHBox>
        );
      }
    }
  ];

  const AlertBar = () => {
    if (isAlertSuccess) {
      return (
        <RBHBox id={'alertSuccess'} data-testid={'alertSuccess'}>
          <RBHAlert
            type={'success'}
            text={'main.cat_category.delete.alert.success'}
            autoCloseDuration={3000}
            afterClose={() => {
              dispatch(martCategoryCreators.setCatState(MART_CATEGORY_STATE_KEY.IS_ALERT_SUCCESS, false));
            }}
          />
          <br />
        </RBHBox>
      );
    } else if (isAlertFailure) {
      return (
        <RBHBox id={'alertFailure'} data-testid={'alertFailure'}>
          <RBHAlert
            type={'error'}
            text={'main.cat_category.delete.alert.failure'}
            autoCloseDuration={3000}
            afterClose={() => {
              dispatch(martCategoryCreators.setCatState(MART_CATEGORY_STATE_KEY.IS_ALERT_FAILURE, false));
            }}
          />
          <br />
        </RBHBox>
      );
    } else {
      return null;
    }
  };

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumb-martCategory-toHome'} id={'breadcrumb-martCategory-toHome'}
              style={styleText.breadCrumbItemLink} onClick={pushToMain}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'breadcrumb-martCategory'} id={'breadcrumb-martCategory'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.mart.category.landing.breadcrumb'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const BreadcrumbTransferRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a id={'breadcrumbMartTransferToHomepage'} data-testid={'breadcrumbMartTransferToHomepage'}
              style={styleText.breadCrumbItemLink} onClick={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: true, onOk: pushToMain, type: MODAL_TYPE.CONFIRM_EDIT
                }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a id={'breadcrumbMartTransferToMartList'} data-testid={'breadcrumbMartTransferToMartList'}
              style={styleText.breadCrumbItemLink} onClick={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: true, onOk: () => resetReload(), type: MODAL_TYPE.CONFIRM_EDIT
                }))}>
              <FormattedMessage id={'main.mart.category.landing.breadcrumb'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span id={'breadcrumbMartTransfer'} data-testid={'breadcrumbMartTransfer'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.mart.category.transfer.breadcrumb'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const TabRender = (props: any) => {
    return (
      <RBHBox style={styles.header}>
        {props.textHeader &&
          <RBHText style={styleText.headerText} text={props.textHeader}
            data-testid={'martCategory-header'} id={'martCategory-header'} />
        }
        {data === undefined || Object.keys(data).length <= 0 ? null
          : <RBHButton id={'addMartCategory-btn'} data-testid={'addMartCategory-btn'} style={styleButton.buttonAdd}
            text={'main.mart.category.landing.btn.addMartCategory'} type='primary' onClick={toAddMartCategory}
            icon={<ProfileOutlined translate={null} />}>
          </RBHButton>
        }
      </RBHBox>
    );
  };

  const TableRender = () => {
    return (
      <RBHTable
        rowKey={'productCategoryMerchantId'}
        loading={loading}
        columns={columns}
        dataSource={data}
        rowClassName={(record: any) => (record.productCategoryGroupingId === 1 ? 'rowPromotion' : null)}
        locale={{
          emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<span id={'table-data-notFound'} data-testid={'table-data-notFound'}>
              <FormattedMessage id={'main.table.notFound'} /> </span>} />
        }}
        pagination={{
          showSizeChanger: false,
          pageSize: DEFAULT_PAGE_SIZE,
          position: ['bottomLeft'],
          hideOnSinglePage: true,
          showTotal: (total: number, range: number[]) => {
            return (<RBHText style={styleText.textPaginationShowTotal}>
              <FormattedMessage id={'main.showing'} />
              <span> {range[0] + '-' + range[1]} </span>
              <FormattedMessage id={'main.of'} />
              <span> {total}</span>
            </RBHText>);
          }
        }}>
      </RBHTable>
    );
  };

  return (
    <RBHBox>
      <AlertBar />
      {transfer ? <BreadcrumbTransferRender /> : <BreadcrumbRender />}
      {loading ? null :
        transfer ?
          <RBHBox>
            <RBHBox style={styles.header}>
              <RBHText style={styleText.headerText} text={'main.mart.category.transfer.header'} data-testid={'martCategoryTransfer'} id={'martCategoryTransfer'} />
            </RBHBox>
            <RBHBox style={styles.defaultContent}>
              <FormTransfer data={transfer} onSuccessCallback={() => resetReload()} onCancel={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: true,
                  onOk: () => resetReload(),
                  type: MODAL_TYPE.CONFIRM_EDIT
                }))} />
            </RBHBox>
          </RBHBox>
          :
          <RBHBox>
            <TabRender textHeader={'main.mart.category.landing.header'} />
            <RBHBox>
              {data === undefined ? <RBHError onOk={() => resetReload()} />
                : Object.keys(data).length <= 0 ? <RBHError onOk={() => resetReload()} />
                  : <RBHBox style={styles.defaultContent}>
                    <TableRender />
                  </RBHBox>}
            </RBHBox>
          </RBHBox>
      }
    </RBHBox>
  );
};

type Props = {};
